var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.48994 3.48085C8.69095 3.27346 9.0245 3.27409 9.22545 3.48153C10.1292 4.41445 11.1759 5.40104 12.196 6.44632C12.2704 6.52262 12.2846 6.6395 12.2341 6.73338V6.73338C12.1546 6.8811 11.9533 6.91244 11.8362 6.79237C11.5512 6.50024 11.2633 6.21167 10.9756 5.92676C10.3774 5.3345 9.77736 4.75098 9.21765 4.18519C9.01904 3.98443 8.69385 3.98442 8.49528 4.18523C7.93582 4.75098 7.33627 5.33469 6.73828 5.92676C5.86588 6.79053 4.98916 7.68532 4.20703 8.62109C2.63447 10.5027 1.50013 12.4837 1.5 14.6191C1.50024 19.0023 4.82423 22.5 8.85742 22.5C12.5157 22.4999 15.5876 19.6218 16.1275 15.8158C16.1472 15.6771 16.2776 15.5811 16.416 15.603V15.603C16.5465 15.6236 16.6425 15.742 16.6241 15.8729C16.0567 19.9065 12.7971 22.9999 8.85742 23L8.45312 22.9893C4.43556 22.7722 1.21361 19.3361 1.00977 15.0508L1 14.6191C1.00025 10.1784 5.52104 6.54403 8.48994 3.48085Z",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8115 1.55273C16.902 1.46138 17.0432 1.45012 17.1465 1.51855L17.1885 1.55273C18.3384 2.71426 19.7247 3.94324 20.8398 5.30859C21.9518 6.67001 22.75 8.11839 22.75 9.68457C22.7498 13.0467 20.1636 15.75 17 15.75C13.8364 15.75 11.2502 13.0467 11.25 9.68457C11.25 8.11839 12.0482 6.67001 13.1602 5.30859C13.9966 4.28448 14.9858 3.33712 15.9131 2.4375L16.8115 1.55273Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGal);
export default __webpack_public_path__ + "static/media/GAL.2af24678f792195d873fd0d4ea4794b5.svg";
export { ForwardRef as ReactComponent };